export default "/images/arrow-down.png?77cabd9f72f7a994c3175d885ce2d9d0";